var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back-button d-md-none d-flex justify-center align-center"},[_c('v-img',{attrs:{"max-width":"25px","src":require("./assets/mobile_goback_icon.png")},on:{"click":function($event){return _vm.goBack()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }